<template>
    <v-container fluid style="min-height:75vh;">
        <az-toolbar>
            <v-flex slot="simpleSearch">
                <az-search
                    :filter="filtrosInterno"
                    @remove-filter="tratarEventoRemoverFiltro"
                    @simple-search="tratarEventoBuscaSimples"
                    id="azSearch"
                    simple-search-placeholder="Busque por: Código, órgão e conta contábil">
                </az-search>
            </v-flex>
            <v-flex>
                <az-menu></az-menu>
            </v-flex>
        </az-toolbar>

        <reavaliacao-listagem-tabela class="tabela-listagem"
                                    :itens="itens"
                                    :paginacao="$store.state.reavaliacao.todasReavaliacoes.paginacao"
                                    :paginas="paginas"
                                    :total-itens="totalItens"
                                    @acessar="tratarEventoAcessar"
                                    @filtrarPorTipo="tratarEventoFiltrarPorTipo"
                                    @paginar="tratarEventoPaginar"
                                    v-if="$store.state.patrimonio.isLista"/>
    </v-container>
</template>

<script>
    import {actionTypes, mutationTypes, tipoPatrimonio} from '@/core/constants'
    import _ from 'lodash'
    import ReavaliacaoListagemTabela from '@/views/pages/patrimonio/reavaliacao/listagem/ReavaliacaoListagemTabela.vue'
    import {mapActions} from 'vuex'

    export default {
        name: 'ReavaliacaoListagem',
        components: {ReavaliacaoListagemTabela},
        data() {
            return {
                filtrosInterno: this.getFiltros(),
                filtrosAvancados:{},
                tipoPatrimonio,
                itens: [],
                paginas: 0,
                totalItens: 0,
                idItemParaDeletar: null
            }
        },
        computed: {
        },
        methods: {
            ...mapActions([
                actionTypes.REAVALIACAO.BUSCAR_REAVALIACOES
            ]),
            async tratarEventoBuscaSimples(valor) {
                this.$store.commit(mutationTypes.REAVALIACAO.RESETA_PAGE)
                this.filtrosInterno.conteudo.value = valor
                await this.buscar()
            },
            async buscar() {
                this.$store.commit(mutationTypes.REAVALIACAO.SET_FILTROS_BUSCA_TODAS_REAVALIACOES, this.getFiltrosInterno())
                await this.buscaTodasReavaliacoes()
            },
            async buscaTodasReavaliacoes() {
                const resultado = await this.buscarReavaliacoes()
                this.itens = resultado.items
                this.paginas = resultado.totalPages
                this.totalItens = resultado.totalElements
            },
            tratarEventoPaginar(paginacao) {
                this.$store.commit(mutationTypes.REAVALIACAO.SET_PAGINACAO_BUSCA_TODAS_REAVALIACOES, paginacao)
                this.buscar()
            },
            tratarEventoFiltrarPorTipo() {
                this.buscar()
            },
            tratarEventoRemoverFiltro(propriedade) {
                if (this.filtrosInterno[propriedade]) {
                    this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
                }
                this.buscar()
            },
            tratarEventoAcessar(item) {
                this.$router.push({
                    name: 'ReavaliacaoDetalhe',
                    params: { reavaliacaoId: item.id },
                })
            },
            getFiltros() {
                return _.cloneDeep(
                    this.$store.state.reavaliacao.todasReavaliacoes.filtros
                )
            },
            getFiltrosInterno() {
                return _.cloneDeep(this.filtrosInterno)
            }
        },
        async mounted() {
            await this.buscaTodasReavaliacoes()
        },
    }
</script>
